<template>
  <v-container fill-height>
    <v-layout
      align-center
      justify-center
    >
      <v-flex class="login-form text-xs-center">
        <v-row
          align="center"
          justify="center"
        >
          <v-col class="d-flex justify-space-around">
            <img
              src="images/logo.jpg"
              width="240"
              height="120"
            >
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
            <v-card class="elevation-12">
              <v-toolbar
                dark
                flat
                color="#FC8333"
              >
                <v-row>
                  <v-col class="d-flex justify-space-around">
                    <v-toolbar-title> Bienvenido </v-toolbar-title>
                  </v-col>
                </v-row>
              </v-toolbar>
              <v-card-text>
                <v-form
                  method="POST"
                  action="/login"
                >
                  <v-text-field
                    v-model="email"
                    label="Email"
                    name="login"
                    prepend-icon="mdi-account"
                    type="email"
                    required
                    autofocus
                  />

                  <v-text-field
                    id="password"
                    v-model="password"
                    label="Contraseña"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    required
                    @keyup.enter="handleSubmit"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="#FC8333"
                  dark
                  @click="handleSubmit"
                >
                  Iniciar Sesión <v-icon>mdi-account-lock</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import apicon from '../plugins/apicon'
export default {
  props: {
    source: String
  },
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      if (this.password.length > 0) {
        apicon
          .saveDataApi(apicon.getApiBaseUrl() + 'authenticate', {
            email: this.email,
            password: this.password
          })
          .then((response) => {
            if (response.status == 'success') {
              localStorage.setItem('userid', response.userid)
              localStorage.setItem('user', response.name)
              localStorage.setItem('cliente', response.cliente);
              localStorage.setItem('jwt', response.api_key)

              if (localStorage.getItem('jwt') != null) {
                this.$router.go('/')
              }
            } else if (response.status == 'fail') {
              this.$swal(response.message)
            }
          })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (localStorage.getItem('jwt')) {
      return next('/')
    }
    next()
  }
}
</script>
<style scoped>
.login-form {
  max-width: 500px;
}
</style>
